import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { CardD, CardDFilter, CardDFiltersMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-card-d-filters',
  styleUrls: ['./card-d-filters.component.scss'],
  templateUrl: './card-d-filters.component.html',
})
export class CardDFiltersComponent extends BaseFiltersComponent<CardD, FilterFieldsOptions<CardDFilter>> {
  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, CardDFiltersMeta);
  }
}
